/**
 * 消息通知新增
 */
import React from 'react';
import AddUser from "../userManage/AddUser";
import {message} from "../../../view/sysManagement/utils/sysManagementUtils";

export default class MessagePushAdd extends AddUser {

    componentWillMount() {
    }

    show(record, onlyView) {
        this.state.onlyView = !!onlyView;
        if (record) {
            this.request({
                url: "/cm-sites-mmp/notice/detail",
                method: "get",
                body: {id: record.id},
                callBack: (res) => {
                    const addFields = this.getAddFields();
                    let addDataObj = {};
                    addDataObj.id = res.id;
                    addFields.forEach(item => {
                        if(res[item.field] || res[item.field] === 0) {
                            addDataObj[item.field] = res[item.field]
                        }
                    })
                    this.state.strLength = addDataObj.content.length;
                    if (res) {
                        this.setState({
                            visible: true,
                            title: "查看消息",
                            addDataObj
                        })
                    }
                }
            });
        } else {
            this.setState({
                visible: true,
                title: "新增消息",
                addDataObj: {},
                strLength: 0
            })
        }
    }

    checkForm = () => {
        const addFields = this.getAddFields();
        for (let i = 0; i < addFields.length; i++) {
            let item = addFields[i];
            if (item.isRequired && !this.state.addDataObj[item.field] && this.state.addDataObj[item.field] !== 0) {
                message.info("请检查必填项！");
                return false;
            }
        }
        return true;
    }

    fieldChange(field, value) {
        this.state.addDataObj[field] = value;
        if (field === "userType" && value === 1 && this.state.addDataObj["deptIds"]) {
            delete this.state.addDataObj.deptIds
        }
        this.setState({});
    }

    saveData() {
        //校验
        if (!this.checkForm()) return false;
        let params = {
            ...this.state.addDataObj
        };
        if (this.state.addDataObj.id) {
            params.id = this.state.addDataObj.id;
        }
        this.request({
            url: "/cm-sites-mmp/notice/add",
            body: params,
            method: "post",
            contentType: "json",
            callBack: (res) => {
                if (res) {
                    message.success("提交成功");
                    this.setState({
                        visible: false,
                    })
                    this.props.refreshList();
                }
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    }

    /**
     * 新增字段
     * type 1  输入框
     * type 2  Select选择框
     * type 3  Cascader级联选择框
     * type 4  单选框
     */
    getAddFields() {
        return (
            [
                {
                    key: "title",
                    field: "title",
                    title: "消息标题",
                    type: "1",
                    maxLength: 10,
                    isRequired: true,
                    disabled: !!this.state.addDataObj.id
                },
                {
                    key: "content",
                    field: "content",
                    title: "消息内容",
                    type: "6",
                    isRequired: true,
                    showStrLength: true,
                    maxLength: 200,
                    disabled: !!this.state.addDataObj.id
                },
                {
                    key: "userType",
                    field: "userType",
                    title: "用户类型",
                    type: "2",
                    isRequired: true,
                    disabled: !!this.state.addDataObj.id,
                    options: [
                        {
                            key: "0",
                            value: 0,
                            title: "全部"
                        },
                        {
                            key: "1",
                            value: 1,
                            title: "外部人员"
                        },
                        {
                            key: "2",
                            value: 2,
                            title: "内部人员"
                        },
                        {
                            key: "3",
                            value: 3,
                            title: "内部管理"
                        },
                    ]
                },
                {
                    key: "dept",
                    field: "deptIds",
                    title: "所属单位",
                    type: this.state.addDataObj["userType"] === 1 ? "" : "4",
                    // isRequired: this.state.addDataObj["userType"] !== 1,
                    disabled: !!this.state.addDataObj.id
                },
            ]
        )
    }

}